module.exports = __webpack_public_path__ + "static/img/bankIcon.de64a375.png";